export class MeetupManagementUserModel {
	uid: number;
	name: string;
	roles: string[];
	status: boolean;
}
